import * as React from 'react';
import { SVGProps } from 'react';

const IconWellKBKSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 1H8v2H5.889L4 4.6 6 7l12-1 2-1.4L18.111 3H16V1ZM5.889 8 18 7l2 2.4-1.889 1.6H5.89L4 9.4 5.889 8Z"
      fill="var(--color-typo-secondary)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 12H8v2H6v5l-2 1.03a3.015 3.015 0 0 0 3.015 3.015h.462L8 22h2l.523 1.045h2.954L14 22h2l.523 1.045h.462A3.015 3.015 0 0 0 20 20.03L18 19v-5h-2v-2Z"
      fill="var(--color-typo-primary)"
    />
  </svg>
);
export default IconWellKBKSizeM;
